import React, { memo } from "react";
import { Colxx } from "../../../components/common/CustomBootstrap";
import STATUS from "../../../constants/status";
import OrderStatus from "../../../containers/dashboards/OrderStatus";
import IntlMessages from "../../../helpers/IntlMessages";

const ListOrderStatus = ({
  itemsOrderStatus,
  itemsPending,
  itemsPendingBill,
  itemsDone,
  onCheckItemPending,
  onCheckItemRefund,
  onCheckItemDone,
  onCheckMultiplePending,
  onCheckMultipleRefund,
  onCheckMultipleDone,
  onActions,
  selectedItemsPending,
  selectedItemsRefund,
  selectedItemsDone,
  companyName,
  companyAddress,
  companyLogo,
  companyWebsite,
  // billDate,
  pin_print,
  handleClickedPrintInvoice,
  switchCheckedBillQr,
  itemsTable,
  switchCheckedOrderTwo,
  isMobileStatusView = false,
}) => {
  return (
    <>
      <Colxx className={`p-0 max-h-170${isMobileStatusView ? " mb-2" : ""}`}>
        <OrderStatus
          popupTitle={<IntlMessages id="dashboards.pending-order" />}
          // popupTitle={'Danh sách các sản phẩm chưa nhận'}
          value={itemsOrderStatus?.order}
          title={<IntlMessages id="dashboards.product-not-receive" />}
          // title={`${itemsOrderStatus?.order} sản phẩm chưa nhận`}
          detail={<IntlMessages id="dashboards.total-order" />}
          // detail={'/Tổng số sản phẩm được order'}
          percent={
            (itemsOrderStatus?.order * 100) / itemsOrderStatus?.totalOrder
          }
          progressText={`${itemsOrderStatus?.order}/${itemsOrderStatus?.totalOrder}`}
          items={itemsPending?.filter((o) => o.status.uuid === STATUS.CREATED)}
          onCheckItem={onCheckItemPending}
          onCheckMultiple={onCheckMultiplePending}
          onActions={onActions}
          selectedItems={selectedItemsPending}
          switchCheckedBillQr={switchCheckedBillQr}
          alias={111}
          role="orders_created"
          emptyText={<IntlMessages id="dashboards.product-received-full" />}
          companyName={companyName}
          companyAddress={companyAddress}
          companyLogo={companyLogo}
          companyWebsite={companyWebsite}
          // emptyText={'Các sản phẩm đã được nhận hết'}
        />
      </Colxx>
      <Colxx className={`p-0 max-h-170${isMobileStatusView ? " mb-2" : ""}`}>
        <OrderStatus
          popupTitle={<IntlMessages id="dashboards.order-undelivery" />}
          // popupTitle={'Danh sách các sản phẩm chưa giao'}
          value={itemsOrderStatus?.pending}
          title={<IntlMessages id="dashboards.product-not-delivery" />}
          // title={`${itemsOrderStatus?.pending} sản phẩm chưa giao`}
          detail={<IntlMessages id="dashboards.total-product-received" />}
          // detail={'/Tổng sản phẩm đã nhận'}
          percent={
            (itemsOrderStatus?.pending * 100) /
            itemsOrderStatus?.totalPendingPayment
          }
          progressText={`${itemsOrderStatus?.pending}/${itemsOrderStatus?.totalPendingPayment}`}
          items={itemsPending?.filter((o) => o.status.uuid !== STATUS.CREATED)}
          onCheckItem={onCheckItemRefund}
          onCheckMultiple={onCheckMultipleRefund}
          onActions={onActions}
          selectedItems={selectedItemsRefund}
          alias={222}
          role="orders_pending"
          emptyText={<IntlMessages id="dashboards.product-delivery-full" />}
          // emptyText={'Các sản phẩm đã được giao hết'}
          switchCheckedOrderTwo={switchCheckedOrderTwo}
          companyName={companyName}
          companyAddress={companyAddress}
          companyLogo={companyLogo}
          companyWebsite={companyWebsite}
        />
      </Colxx>

      <Colxx
        className={`p-0 max-h-170${isMobileStatusView ? " mb-2" : ""}`}
        id="list-orders-status"
      >
        <OrderStatus
          popupTitle={<IntlMessages id="dashboards.order-pending-payment" />}
          // popupTitle={'Danh sách các bàn chưa thu tiền'}
          value={itemsOrderStatus?.tablePendingPayment}
          title={<IntlMessages id="dashboards.table-notyet-pay" />}
          // title={`${itemsOrderStatus?.tablePendingPayment} bàn chưa thu tiền`}
          detail={<IntlMessages id="dashboards.total-table-has-customer" />}
          // detail={'/Tổng bàn có khách trong ngày'}
          percent={
            (itemsOrderStatus?.tablePendingPayment * 100) /
            itemsOrderStatus?.totalTableHasGuest
          }
          progressText={`${itemsOrderStatus?.tablePendingPayment}/${itemsOrderStatus?.totalTableHasGuest}`}
          items={itemsDone?.filter((o) => o.status.uuid === STATUS.COMPLETED)}
          onCheckItem={onCheckItemDone}
          onCheckMultiple={onCheckMultipleDone}
          onActions={onActions}
          selectedItems={selectedItemsDone}
          alias={444}
          role="orders_table_pending_payment"
          emptyText={<IntlMessages id="dashboards.table-payment-full" />}
          // emptyText={'Các bàn đã được thanh toán hết'}
          itemsPendingBill={itemsPendingBill}
          companyName={companyName}
          companyAddress={companyAddress}
          companyLogo={companyLogo}
          companyWebsite={companyWebsite}
          // billDate={billDate}
          pin_print={pin_print}
          handleClickedPrintInvoice={handleClickedPrintInvoice}
          itemsTable={itemsTable}
        />
      </Colxx>
    </>
  );
};

export default memo(ListOrderStatus);
